import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const SingleDataChart = ({ title, value }) => {
  const data = [{ name: title, value }];

  return (
    <div style={{ width: "100%", height: 300 }}>
      <h4>{title}</h4>
      <ResponsiveContainer>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" />
          <Tooltip />
          <Bar dataKey="value" fill="#8884d8" barSize={100} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SingleDataChart;
